export const environment = {
  production: true,
  payUrl:'http://lk.renlife.com/payment/',
  keycloakCongig:{
    url: 'https://auth.cloud.renlife.com/auth',
    realm: 'prod',
    clientId: 'lka-frontend'
  },
  keycloackAdapterUrl:"https://auth.cloud.renlife.com/auth/js/keycloak.js"
};
